import React from 'react';
import ArrowDown from '../../../assets/svgs/arrow-down.svg';
import { IssueNav } from './index';

const ContextNav = ({
  issueName,
  issueDate,
  toggleIssueNavList,
  showIssueNavList,
  publishedIssues,
}) => (
  <>
    {issueName && (
      <div className="site-header__links-toc-current">
        <button className="site-header__links-toc-current-name" onClick={toggleIssueNavList}>
          {issueName} <ArrowDown />
        </button>
        <div className="site-header__links-toc-current-date">
          <span>| </span>
          <span>{issueDate}</span>
          <span>{issueDate && issueDate.replace(/^\d* /, '')}</span>
        </div>
      </div>
    )}
    {showIssueNavList && (
      <ul className="site-header__links-toc-list">
        <li style={{ '--order': 0 }}><strong>Issues</strong></li>
        {publishedIssues
          .map((issue, idx) => (
            <IssueNav
              issue={issue}
              idx={idx}
              toggleNavList={toggleIssueNavList}
              key={issue.databaseId}
              group={issue.tghpwipIssuesTaxonomyCategory !== 'film' ? 1 : 3}
            />
          ))}
        <li style={{ '--order': 2 }}><strong>Films</strong></li>
      </ul>
    )}
  </>
);

export default ContextNav;
